import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Component to surface in storybook
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Responsive', module)

stories.addDecorator(withReadme(readme))

// Stories
stories
  .add('Default', () => (
    'No story yet. Somebody needs to make one!'
  ))
